import {isRef, subscribeToRef} from '@servicenow/ui-internal';

const refUnsubs = new Map();
export function parseRefProperty(host, name, value) {
	const isReference = isRef(value);
	let unsubs = refUnsubs.get(host);
	const ref = unsubs?.get(name)?.ref;

	if (ref && (ref.current !== value || isReference)) {
		if (unsubs) {
			unsubs.get(name)?.fn();
			unsubs.delete(name);
			if (unsubs.size === 0) {
				refUnsubs.delete(host);
				unsubs = null;
			}
		}
	}

	if (isReference) {
		refUnsubs.set(
			host,
			(unsubs || new Map()).set(name, {fn: subscribeToRef(value, host, name), ref: value})
		);
		return value.current;
	}
	return value;
}

export function getUnsubscribe(host, propName) {
	return refUnsubs.get(host)?.get(propName);
}

export function getHostUnsubs(host) {
	return refUnsubs.get(host);
}
